/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const EditBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M18.861 3.138a.471.471 0 0 0-.666 0l-1.69 1.69 2.668 2.67 1.689-1.69a.472.472 0 0 0 0-.668l-2-2.002ZM15.527 5.807l2.668 2.67L6.489 20.188a.66.66 0 0 1-.314.172L3.573 21c-.265.004-.572-.3-.573-.568v-.005l.65-2.596a.658.658 0 0 1 .17-.31L15.527 5.807Z" /></g></svg>);
const Edit = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={EditBase} {...rest} ref={ref} />);
export default Edit;